/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../common/order_source';
import '../../resources/order';
import '../../../../connect/v2/resources/error';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "service": {
                "nested": {
                  "RetrieveLatestActiveOrderRequest": {
                    "fields": {
                      "storeCode": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "source": {
                        "type": "squareup.solidshop.v2.common.OrderSource",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "RetrieveLatestActiveOrderResponse": {
                    "fields": {
                      "order": {
                        "type": "squareup.solidshop.v2.resources.Order",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": "squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.service?.nested?.RetrieveLatestActiveOrderRequest && !$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.service?.nested?.RetrieveLatestActiveOrderResponse) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE RetrieveLatestActiveOrderRequest @ squareup/solidshop/v2/service/orders/retrieve_latest_active_order.proto at 12:1
 */
export const RetrieveLatestActiveOrderRequest = $root.lookupType('squareup.solidshop.v2.service.RetrieveLatestActiveOrderRequest');
fixType(RetrieveLatestActiveOrderRequest);
Builder.createAndAttachToType(RetrieveLatestActiveOrderRequest);
/**
 * SOURCE RetrieveLatestActiveOrderResponse @ squareup/solidshop/v2/service/orders/retrieve_latest_active_order.proto at 20:1
 */
export const RetrieveLatestActiveOrderResponse = $root.lookupType('squareup.solidshop.v2.service.RetrieveLatestActiveOrderResponse');
fixType(RetrieveLatestActiveOrderResponse);
Builder.createAndAttachToType(RetrieveLatestActiveOrderResponse);
